import { createResource, createSignal } from "solid-js";

export function createResourceWithInitialData(fetcher, initialData, dependencies = () => undefined) {
    const [isFirstLoad, setIsFirstLoad] = createSignal(true);

    const [resource, { refetch, mutate }] = createResource(dependencies, async (args) => {
        if (isFirstLoad()) {
            setIsFirstLoad(false);
            return initialData;
        }

        return fetcher(args);
    });

    return [resource, { refetch, mutate }];
}

